angular.module('mercury.modules.reports.items')
  .factory('PosItemGroups', ["$resource", "settings", function($resource, settings) {
    var PosItemGroupOrders = $resource(settings.mercHost + '/pos/orders/item-groups');
    var PosItemGroupSales = $resource(settings.mercHost + '/pos/sales/item-groups');

    function getOrders(start, end) {
      return PosItemGroupOrders.query({start: start, end: end}).$promise;
    }

    function getSales(start, end) {
      return PosItemGroupSales.query({start: start, end: end}).$promise;
    }
    return {
      getOrders: getOrders,
      getSales: getSales
    };
  }]);
